var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "67px",
    viewBox: "0 0 63 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/Coin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Coin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0851818,9.57236058 C27.4711818,6.55690604 36.3061818,7.03599695 41.2267273,8.50708786 C47.5083921,10.6438751 52.1223531,14.0351389 55.3074935,18.0352222 L56.8770597,15.7900183 C57.5864213,16.8316997 59.9353649,21.4485365 60.3289196,23.0290852 C60.7224743,24.6096338 61.2901012,28.450792 61.2901012,30.6105172 C61.2901012,32.1232441 61.2010547,33.5110941 61.0368617,34.833819 C61.0598362,40.2956945 59.6853022,46.152991 55.9883636,52.436906 C51.5976364,60.1840879 42.9825318,64.3541288 34.58435,65.3264015 C19.4507136,68.3221288 4.17540838,55.6045424 2.69090909,40.3863606 C-0.147,27.2733606 9.08536364,14.2674515 21.0851818,9.57236058 Z",
    id: "Combined-Shape",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#000000",
    opacity: 0.2,
    style: {
      mixBlendMode: "darken"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "COIN",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2267273,2.50254545 C35.3061818,1.03145455 26.4711818,0.552363636 20.0851818,3.56781818 C8.08536364,8.26290909 -1.147,21.2688182 1.69090909,34.3818182 C3.17540838,49.6 18.4507136,62.3175864 33.58435,59.3218591 C41.9825318,58.3495864 50.5976364,54.1795455 54.9883636,46.4323636 C59.2182105,39.2426314 60.4078535,32.6113751 59.9430575,26.4909091 C59.2182105,16.946073 53.3765694,6.97562948 40.2267273,2.50254545 Z",
    id: "STROKE_3b41c18f-5c57-4e76-b696-1a3e6ef9a18c",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#8993AB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31.062059, 31.347546) rotate(24.000000) translate(-31.062059, -31.347546) translate(8.062059, 8.347546)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5945421,0.263123244 C19.4270708,-1.11741894 9.75762483,3.0336204 4.46114962,10.3881451 C-3.45138534,21.6301511 -0.909334664,39.0438082 13.5932253,43.5556711 C30.0039323,50.3830797 48.2359059,33.1733664 44.6931238,16.8861062 C42.9136884,9.22723465 36.0662405,2.6508337 28.6041955,0.256848053",
    id: "STROKE_28f61f43-c965-45e8-9d68-e7ecc4264e98",
    stroke: "#6A7795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7738104,44.2649326 C11.1322629,43.4412199 6.82765531,40.1017845 5.15298379,38.2498758 C0.337139496,32.2302685 -1.31344875,24.6172148 1.09909529,17.4038619 C2.60106651,12.0496547 5.34198024,8.02102585 10.0715917,4.62626957 C14.8012032,1.23151329 19.086471,-1.6019509e-14 25.3468419,-1.6019509e-14",
    id: "STROKE_cefaf9a6-f5f2-4003-8036-13bb4891d9a4",
    stroke: "#B1BACF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.3951616,59.3045632 C33.4358888,60.7136541 42.3093636,58.6069091 49.7775455,53.1199091 C53.723,50.2735455 55.8394545,46.748 57.7980909,42.4108182 C59.2832727,37.8763636 60.2901012,34.2016912 60.2901012,29.1150657 C60.2901012,26.9553406 59.7224743,23.1141824 59.3289196,21.5336337 C58.9353649,19.953085 56.5864213,15.3362482 55.8770597,14.2945668",
    id: "STROKE_307cf84a-6fbd-481b-b8c3-aaf2e1d8f7f9",
    stroke: "#000000",
    strokeWidth: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.2c7e2334810e3b677913ae61579eec53.svg";
export { ForwardRef as ReactComponent };